import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Resolves a GT's department_id into the list of network store department_ids
 * that match the GT's business sectors.
 *
 * Uses the `get_gt_network_department_ids` SECURITY DEFINER function.
 *
 * @param gtDepartmentId - The department ID of the GT at the HQ store. Pass null/undefined to skip.
 * @returns { departmentIds, isLoading }
 */
export function useGTNetworkDepartments(gtDepartmentId: string | null | undefined) {
  const { data: departmentIds = null, isLoading } = useQuery<string[] | null>({
    queryKey: ["gt-network-departments", gtDepartmentId],
    enabled: !!gtDepartmentId,
    staleTime: 1000 * 60 * 30, // 30 min cache — mapping is quasi-static
    queryFn: async () => {
      const { data, error } = await supabase.rpc(
        "get_gt_network_department_ids" as any,
        { _gt_department_id: gtDepartmentId }
      );
      if (error) {
        console.error("[useGTNetworkDepartments]", error);
        return [];
      }
      // RPC returns uuid[] — supabase-js deserializes as string[]
      return (data as string[]) ?? [];
    },
  });

  return { departmentIds, isLoading };
}
